/**
 * AppShell — global layout: navbar + outlet + footer.
 */
import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import Navbar from "./Navbar";
import Footer from "./Footer";

export default function AppShell() {
    const location = useLocation();
    const isLanding = location.pathname === "/";

    useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    }, [location.pathname]);

    return (
        <div className="min-h-screen bg-graphite-900 text-white">
            <Navbar />
            <motion.main
                key={location.pathname}
                initial={{ opacity: 0, y: 8 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.28, ease: [0.22, 1, 0.36, 1] }}
                className={isLanding ? "" : "pt-24 pb-24"}
            >
                <Outlet />
            </motion.main>
            <Footer />
        </div>
    );
}
